import type { JSX } from 'react';
import { ConfigSection } from '../components/ConfigSection.js';

export function AiPage(): JSX.Element {
  return (
    <ConfigSection
      title={"IA configurável por feature"}
      description={"Área do plano que depende de código ou credencial externa."}
      blockedBy={[
      '`packages/ai` não implementado nesta revisão (F-10).',
      'Sem `AI_OPENAI_KEY`/`AI_GEMINI_KEY`, nenhuma feature de IA pode ser exercitada.',
      'O schema de configuração (`ConfigVersion`) e o kill switch já existem no ambiente.'
]}
      planned={[
      'Adapters suportados, catálogo de modelos, roteamento por feature, quotas e kill switch.',
      'Prompt versionado por job: o job não troca de prompt no meio da execução.'
]}
    />
  );
}